module.exports = __webpack_public_path__ + "img/avtDefault.daf05c8a.jpg";